module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-list-filter"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "filter-btns"
  }, [_vm._t("btns")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3afa70e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/list/rtListFilter.vue
// module id = 1416
// module chunks = 116